import React, { FC } from 'react';

import { getMessage } from './helpers';
import * as Styled from './styled';
import { DataType, Reason } from './types';

type Props = {
  dataType: DataType;
  reason: Reason;
};

/**
 * No result for list
 *
 * @param props          Props passed to the component
 * @param props.dataType Type of data used inside of list
 * @param props.reason   Why is there nothing to show
 * @returns              The component itself
 */
const NoResult: FC<Props> = ({ dataType, reason }) => {
  return <Styled.Title>{getMessage(dataType, reason)}</Styled.Title>;
};

export default NoResult;
